module.exports = __webpack_public_path__ + "img/tinder.d67e3b53.svg";